import { AuthGuard } from './../authentication/guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GoalsComponent } from './components/goals/goals.component';

const routes: Routes = [
  {
    path: 'goal-portal',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'goals-list',
        component: GoalsComponent,
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoalRoutingModule {}
